import { IAlertConfig } from '../../../models/bootstrap/Alert' 

export class FiltersModalController {
    alerts: IAlertConfig[] = []


    childNoSlider = {
        stepsArray: [
            { value: 1, legend: '1 child' },
            { value: 2, legend: '2 children' },
            { value: 3, legend: '3 children' },
            { value: 4, legend: '4 children' },
            { value: 5, legend: '5 or more children' },
        ],
        showTicks: true,
        hideLimitLabels: true,
        hidePointerLabels: true
    }

    childAgeSlider = {
        stepsArray: [
            { value: 0, legend: '0' },
            { value: 1, legend: '1' },
            { value: 2, legend: '2' },
            { value: 3, legend: '3' },
            { value: 4, legend: '4' },
            { value: 5, legend: '5' },
            { value: 6, legend: '6+' }
        ],
        showTicks: true,
        hideLimitLabels: true,
        hidePointerLabels: true
    }

    regions = [
        { name: 'East Coast', value: 'EAC'},
        { name: 'Mid Atlantic', value: 'MAT'},
        { name: 'Mid West', value: 'MIW'},
        { name: 'Mountains', value: 'MT'},
        { name: 'New England', value: 'NWG'},
        { name: 'NYC Metro Area', value: 'NYM'},
        { name: 'South', value: 'SOU'},
        { name: 'South West', value: 'SOW'},
        { name: 'West Coast', value: 'WEC' }
    ]


    static $inject = ['$uibModalInstance', '$timeout', '$scope', 'HostFamiliesResult', 'filters'];
    constructor(private $uibModalInstance, private $timeout, private $scope, private HostFamiliesResult, private filters) {

        $timeout(function () {
            $scope.$broadcast('rzSliderForceRender')
        })
    }

    toggle(region) {
        if (!this.filters.region) {
            this.filters.region = {}
        }

        this.filters.region[region.value] = !this.filters.region[region.value];
    }

    validate() {
        this.$scope.$broadcast('submitted', true)
        return this.filters.$validation();
    }

    save() {
        //if (!this.validate()) {
        //    return
        //}

        this.alerts = [];

        //this.HostFamiliesResult.save(this.filters).$promise
        //    .then(() => {
        //        this.$uibModalInstance.close();
        //    }, () => {
        //        this.alerts.push({
        //            type: 'danger',
        //            msg: 'We are sorry but agency is not created. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
        //            dismissOnTimeout: 5000
        //        });
        //    });

        this.$uibModalInstance.close(this.filters);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    clear() {
        this.filters.fromAge = 0;
        this.filters.toAge = 6;

        this.filters.minChild = 1;
        this.filters.maxChild = 5;

        this.filters.region = {}
    }
}

